import React from "react";

export default function ImagePage() {
  const params = new URLSearchParams(window.location.search);
  const imageUrl = params.get("image");

  const handleClose = () => {
    window.close();
  };

  return (
    <section>
        <button
          onClick={handleClose}
          style={{
            position: "absolute",
            top: "10px",
            left: "55px",
            backgroundColor: "#6c48b0",
            color: "white",
            padding: "5px 20px",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Fechar
        </button>
      <div
        style={{ position: "relative", textAlign: "center", margin: "55px" }}
      >
        
        <figure>
          <img
            src={imageUrl}
            alt="Imagem ampliada"
            style={{ maxWidth: "90%", maxHeight: "80vh" }}
          />
        </figure>
      </div>
    </section>
  );
}
